#import "./requisition/fragments.graphql"

# Caller's inbox. Filter and page on the server. Load once, refetch after a write.
# Add a kind: spread its fragment on items (see requisition/fragments.graphql).
query inbox($filter: InboxFilter, $paging: InboxPaging) {
  inbox(filter: $filter, paging: $paging) {
    total
    counts {
      category
      count
    }
    items {
      id
      kind
      owedAs
      since
      slaHours
      overdue
      ...RequisitionApprovalInboxFields
      ...RequisitionExceptionReasonInboxFields
    }
  }
}
